export default __webpack_public_path__ + "static/media/Avatar-7.d1759d91.png";